import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
// import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Select from 'react-select'
import Alert from 'component/utils/Alert'

import _ from 'lodash'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class GamaFormSection extends Component {
  state = {
    loading: true,
    alert: {
      show: false,
      message: '',
    },
  }

  componentDidUpdate(prevProps) {
    /* istanbul ignore else */
    if (prevProps.gamaSecModels !== this.props.gamaSecModels) {
      this.mountGama(prevProps)
    }

    if (prevProps.savedGama !== this.props.savedGama) {
      this.forceUpdate()
    }
  }

  async mountGama() {
    let newGamaSecModels = JSON.parse(
      sessionStorage.getItem('leroyGamaSections')
    )
    /* istanbul ignore else */
    if (!newGamaSecModels) {
      // sets new object params
      newGamaSecModels = this.props.gamaSecModels.map((obj) => ({
        ...obj,
        subSecOptions: {
          loading: false,
          options: [],
          selectedOptions: [],
          selectedBefore: [],
        },
        typeOptions: {
          loading: false,
          options: [],
          selectedOptions: [],
          selectedBefore: [],
        },
        subTypeOptions: {
          loading: false,
          options: [],
          selectedOptions: [],
          selectedBefore: [],
        },
      }))

      // Sets subSection options
      await Promise.all(
        newGamaSecModels.map(async (sec, i) => {
          // Sets loading
          newGamaSecModels[i].subSecOptions.loading = true

          const params = {
            level: 3,
            sectionId: sec.sectionId,
            subSectionId: 0,
            typeId: 0,
            subTypeId: 0,
            limit: 50,
            offset: 0,
          }

          const options = await this.fetchData(params).catch(
            /* istanbul ignore next */
            (err) => {
              console.log(err)
            }
          )

          newGamaSecModels[i] = {
            ...sec,
            subSecOptions: {
              ...newGamaSecModels[i].subSecOptions,
              options: [
                ...(options && options.length
                  ? options.map((option) => ({
                      ...option,
                      value: option.subSectionId,
                      label: option.description,
                    }))
                  : []),
              ],
            },
          }

          newGamaSecModels[i].subSecOptions.loading = false
        })
      )

      // sessionStorage.setItem('leroyGamaSections', JSON.stringify(newGamaSecModels))
    }

    await this.setState({ gamaSecModels: newGamaSecModels, loading: false })
    /* istanbul ignore else */
    if (this.props.savedGama) {
      this.populateGama()
    }
  }

  handleAlert = (message) => {
    this.setState((prevState) => ({
      alert: {
        show: !prevState.alert.show,
        message: message || '',
      },
    }))
  }

  fetchData = async (params) => {
    const { user } = this.props
    /* istanbul ignore else */
    if (user) {
      try {
        const { data } = await new Api(user.dsToken).post(
          API_URL.SECTIONS_HIERARCHY,
          params
        )

        return data
      } catch (error) {
        return error
      }
    }
  }

  populateGama = async () => {
    const { savedGama } = this.props
    const { gamaSecModels } = this.state

    console.warn(savedGama)

    await this.setState({ savedGama })

    await this._checkSavedParams([...gamaSecModels])
  }

  _checkSavedParams = (newGamaSecModels) => {
    const { savedGama } = this.state
    /* istanbul ignore else */
    if (!savedGama) return false

    /* istanbul ignore else */
    if (savedGama.gamaSecParams) {
      newGamaSecModels.map(async (section, index) => {
        let subSecOpt = []
        let typeOpt = []
        let subTypeOpt = []

        // sections
        /* istanbul ignore else */
        if (savedGama.gamaSecParams) {
          await Promise.all(
            savedGama.gamaSecParams.map(async (savedSec) => {
              /* istanbul ignore else */
              if (section.sectionId === savedSec.sectionId) {
                subSecOpt = await savedGama.gamaSubSecParams
                  .filter(
                    (savedSubSec) => section.sectionId === savedSubSec.sectionId
                  )
                  .map((option) => ({
                    level: 3,
                    description: option.description || '',
                    sectionId: option.sectionId,
                    subSectionId: option.subSectionId,
                    typeId: option.typeId || 0,
                    subTypeId: option.subTypeId || 0,
                    value: option.subSectionId || 0,
                    label: option.description || '',
                  }))

                typeOpt = await savedGama.gamaTypeParams
                  .filter(
                    (savedType) => section.sectionId === savedType.sectionId
                  )
                  .map((option) => ({
                    level: 4,
                    description: option.description || '',
                    sectionId: option.sectionId,
                    subSectionId: option.subSectionId,
                    typeId: option.typeId,
                    subTypeId: option.subTypeId || 0,
                    value: option.typeId || 0,
                    label: option.description || '',
                  }))

                subTypeOpt = await savedGama.gamaSubTypeParams
                  .filter(
                    (savedSubType) =>
                      section.sectionId === savedSubType.sectionId
                  )
                  .map((option) => ({
                    level: 5,
                    description: option.description || '',
                    sectionId: option.sectionId,
                    subSectionId: option.subSectionId,
                    typeId: option.typeId,
                    subTypeId: option.subTypeId,
                    value: option.idSubType,
                    label: option.description,
                  }))

                const inAll = !!parseInt(savedSec.inAll, 10)

                section = {
                  ...section,
                  inAll,
                  subSecOptions: {
                    ...section.subSecOptions,
                    selectedBefore: [],
                    selectedOptions: subSecOpt,
                    options: [...section.subSecOptions.options],
                  },
                  typeOptions: {
                    ...section.typeOptions,
                    selectedBefore: [],
                    selectedOptions: typeOpt,
                  },
                  subTypeOptions: {
                    ...section.subTypeOptions,
                    selectedBefore: [],
                    selectedOptions: subTypeOpt,
                  },
                }

                await this.handleSelectChange(
                  subSecOpt,
                  'subSecOptions',
                  index,
                  4
                )
                await this.handleSelectChange(typeOpt, 'typeOptions', index, 5)
                await this.handleSelectChange(
                  subTypeOpt,
                  'subTypeOptions',
                  index,
                  6
                )

                !inAll || (await this.handleChange(index))
              }
            })
          )
        }
      })
    }
  }

  handleChange = (secIndex) => {
    const gamaSecModels = [...this.state.gamaSecModels]

    gamaSecModels[secIndex] = {
      ...gamaSecModels[secIndex],
      inAll: !gamaSecModels[secIndex].inAll,
    }

    this.setState({ gamaSecModels })
  }

  handleSelectChange = async (selectedOptions, selfSelect, secIndex, level) => {
    const gamaSecModels = [...this.state.gamaSecModels]

    selectedOptions = selectedOptions || []

    gamaSecModels[secIndex][selfSelect].selectedOptions = selectedOptions

    await this.setState({ gamaSecModels })

    /* istanbul ignore next */
    await _.debounce(() => {
      this.handleSelectOptions(secIndex, level)
    }, 300)()
  }

  handleSelectOptions = async (i, level) => {
    const newGamaSecModels = [...this.state.gamaSecModels]
    let target
    let value

    switch (level) {
      case 4:
        target = ['subSecOptions', 'typeOptions']
        value = ['subSectionId', 'typeId']
        break

      case 5:
        target = ['typeOptions', 'subTypeOptions']
        value = ['typeId', 'subTypeId']
        break

      case 6:
        target = ['subTypeOptions', false]
        value = ['subTypeId', false]
        break

      default:
        target = ['subSecOptions', 'typeOptions']
        value = ['subSecOptions', 'typeId']
        break
    }

    const { selectedOptions, selectedBefore } = newGamaSecModels[i][target[0]]

    const newRemoves = selectedBefore.filter(
      (selected) => !selectedOptions.includes(selected)
    )
    /* istanbul ignore else */
    if (newRemoves.length && target[1]) {
      await this.removeOptions(
        i,
        level,
        newGamaSecModels,
        target,
        value[0],
        newRemoves
      )
    }

    const newSelections = selectedOptions.filter(
      (selected) => !selectedBefore.includes(selected)
    )
    /* istanbul ignore else */
    if (newSelections.length && value[1] && target[1]) {
      await this.loadOptions(
        i,
        level,
        newGamaSecModels,
        target,
        value[1],
        newSelections
      )
    }

    // sets selectedBefore
    newGamaSecModels[i][target[0]].selectedBefore = [
      ...newGamaSecModels[i][target[0]].selectedOptions,
    ]
  }

  loadOptions = async (
    i,
    level,
    newGamaSecModels,
    target,
    value,
    newSelections
  ) => {
    // sets loading
    newGamaSecModels[i][target[1]].loading = true

    this.setState({ gamaSecModels: newGamaSecModels })

    await Promise.all(
      newSelections.map(async (selected) => {
        const params = {
          level,
          sectionId: selected.sectionId,
          subSectionId: selected.subSectionId,
          typeId: selected.typeId,
          subTypeId: selected.subTypeId,
          limit: 50,
          offset: 0,
        }

        const options = await this.fetchData(params).catch(
          /* istanbul ignore next */
          (err) => {
            console.log(err)
          }
        )

        newGamaSecModels[i][target[1]] = {
          ...newGamaSecModels[i][target[1]],
          options: [
            ...newGamaSecModels[i][target[1]].options,
            ...(options && options.length
              ? options.map((option) => ({
                  ...option,
                  value: option[value],
                  label: option.description,
                }))
              : []),
          ],
        }

        return newGamaSecModels[i][target[1]].options
      })
    )
      .catch(
        /* istanbul ignore next */
        (err) => {
          console.log(err.message)
          // this.handleAlert('irc.gama.fetchOptionsErr')
        }
      )
      .finally(() => {
        newGamaSecModels[i][target[1]].loading = false
        this.setState({ gamaSecModels: newGamaSecModels })
      })
  }

  removeOptions = async (
    i,
    level,
    newGamaSecModels,
    target,
    value,
    newRemoves
  ) => {
    // sets loading
    newGamaSecModels[i][target[1]].loading = true
    this.setState({ gamaSecModels: newGamaSecModels })
    await Promise.all(
      newRemoves.map(async (removed) => {
        /* istanbul ignore else */
        if (removed.level === 3) {
          newGamaSecModels[i].typeOptions = {
            ...newGamaSecModels[i].typeOptions,
            options: newGamaSecModels[i].typeOptions.options.filter(
              (option) => option.subSectionId !== removed.subSectionId
            ),
            selectedOptions: newGamaSecModels[
              i
            ].typeOptions.selectedOptions.filter(
              (option) => option.subSectionId !== removed.subSectionId
            ),
            selectedBefore: newGamaSecModels[
              i
            ].typeOptions.selectedBefore.filter(
              (option) => option.subSectionId !== removed.subSectionId
            ),
          }

          newGamaSecModels[i].subTypeOptions = {
            ...newGamaSecModels[i].subTypeOptions,
            options: newGamaSecModels[i].subTypeOptions.options.filter(
              (option) =>
                !(
                  option.sectionId === removed.sectionId &&
                  option.subSectionId === removed.subSectionId
                )
            ),
            selectedOptions: newGamaSecModels[
              i
            ].subTypeOptions.selectedOptions.filter(
              (option) =>
                !(
                  option.sectionId === removed.sectionId &&
                  option.subSectionId === removed.subSectionId
                )
            ),
            selectedBefore: newGamaSecModels[
              i
            ].subTypeOptions.selectedBefore.filter(
              (option) =>
                !(
                  option.sectionId === removed.sectionId &&
                  option.subSectionId === removed.subSectionId
                )
            ),
          }
        } else if (removed.level === 4) {
          newGamaSecModels[i].subTypeOptions = {
            ...newGamaSecModels[i].subTypeOptions,
            options: newGamaSecModels[i].subTypeOptions.options.filter(
              (option) => option.typeId !== removed.typeId
            ),
            selectedOptions: newGamaSecModels[
              i
            ].subTypeOptions.selectedOptions.filter(
              (option) => option.typeId !== removed.typeId
            ),
            selectedBefore: newGamaSecModels[
              i
            ].subTypeOptions.selectedBefore.filter(
              (option) => option.typeId !== removed.typeId
            ),
          }
        }
      })
    )
      .catch(
        /* istanbul ignore next */
        (err) => {
          console.log(err.message)
          // this.handleAlert('irc.gama.fetchOptionsErr')
        }
      )
      .finally(() => {
        newGamaSecModels[i][target[1]].loading = false
        this.setState({ gamaSecModels: newGamaSecModels })
      })
  }

  renderSections = () => {
    const { containerClass, translate } = this.props
    const { gamaSecModels } = this.state

    return gamaSecModels.map((section, secIndex) => (
      <Row
        key={section.sectionId}
        className={`margin-bottom ${containerClass || ''}`}
      >
        <Col xs={12} className='margin-bottom'>
          <div className='accordion-gama-section-title'>
            {`${secIndex + 1} - ${section.description}`}
            <div className='field'>
              <Input
                name={`inAll-${section.sectionId}`}
                id={`inAll-${section.sectionId}`}
                type='checkbox'
                label={translate('irc.gama.labelInAll')}
                checked={section.inAll}
                onChange={() => this.handleChange(secIndex)}
              />
            </div>
          </div>
        </Col>
        <Col xs={12} sm={4}>
          <Select
            name={`subSec-${section.sectionId}`}
            isMulti
            closeMenuOnSelect={false}
            className={'react-select react-select-multi'}
            classNamePrefix={'react-select'}
            value={
              section.subSecOptions ? section.subSecOptions.selectedOptions : []
            }
            options={section.subSecOptions ? section.subSecOptions.options : []}
            onChange={(selectedOptions) =>
              this.handleSelectChange(
                selectedOptions,
                'subSecOptions',
                secIndex,
                4
              )
            }
            disabled={section.inAll}
            placeholder={translate(
              section.subSecOptions.loading
                ? 'irc.gama.selectLoading'
                : 'irc.gama.subSecPlaceholder'
            )}
            noResultsText={translate('irc.gama.selectNoOptionsMessage')}
          />
        </Col>
        <Col xs={12} sm={4}>
          <Select
            name={`typeSec-${section.sectionId}`}
            isMulti
            closeMenuOnSelect={false}
            className={'react-select react-select-multi'}
            classNamePrefix={'react-select'}
            value={
              section.typeOptions ? section.typeOptions.selectedOptions : []
            }
            options={section.typeOptions ? section.typeOptions.options : []}
            onChange={(selectedOptions) =>
              this.handleSelectChange(
                selectedOptions,
                'typeOptions',
                secIndex,
                5
              )
            }
            disabled={
              section.inAll || !section.subSecOptions.selectedOptions.length
            }
            placeholder={translate(
              section.typeOptions.loading
                ? 'irc.gama.selectLoading'
                : 'irc.gama.typePlaceholder'
            )}
            noResultsText={translate('irc.gama.selectNoOptionsMessage')}
          />
        </Col>
        <Col xs={12} sm={4}>
          <Select
            name={`subTypeSec-${section.sectionId}`}
            isMulti
            closeMenuOnSelect={false}
            className={'react-select react-select-multi'}
            classNamePrefix={'react-select'}
            value={
              section.subTypeOptions
                ? section.subTypeOptions.selectedOptions
                : []
            }
            options={
              section.subTypeOptions ? section.subTypeOptions.options : []
            }
            onChange={(selectedOptions) =>
              this.handleSelectChange(
                selectedOptions,
                'subTypeOptions',
                secIndex,
                6
              )
            }
            disabled={
              section.inAll ||
              !section.subSecOptions.selectedOptions.length ||
              !section.typeOptions.selectedOptions.length
            }
            placeholder={translate(
              section.subTypeOptions.loading
                ? 'irc.gama.selectLoading'
                : 'irc.gama.subTypePlaceholder'
            )}
            noResultsText={translate('irc.gama.selectNoOptionsMessage')}
          />
        </Col>
      </Row>
    ))
  }

  render() {
    const { translate } = this.props
    const { gamaSecModels, alert, loading } = this.state

    return (
      <div>
        {loading && <div className='margin-bottom'>{translate('loading')}</div>}

        {!loading && alert.show && (
          <Alert
            handleAlert={this.handleAlert}
            text={translate(alert.message)}
            translate={translate}
            textButton={translate('irc.gama.closeAlert')}
            preventDefault
            size='sm'
          />
        )}

        {!loading && gamaSecModels && this.renderSections()}
      </div>
    )
  }
}

GamaFormSection.propTypes = {
  gamaSecModels: PropTypes.array.isRequired,
  savedGama: PropTypes.object,
  containerClass: PropTypes.string,
  translate: PropTypes.func,
  user: PropTypes.object,
}
export default GamaFormSection
